const ChargingStatus = {
  ForCharging: "for-charging",
  Waived: "waived",
};

export default ChargingStatus;
